<div class="notification-container" [ngClass]="type">
    <img [src]="getIconPath()" alt="{{ type }} icon">
    <span class="notification-text">{{ message }}</span>
  </div>